import commonManagerApi from "api/commonManagerApi";

export { useCommonManagerActions };

function useCommonManagerActions() {
   const clearCacheKMS = async (langCode) => {
      try {
         return await commonManagerApi.clearCacheKMS(langCode);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   return {
      clearCacheKMS,
   };
}
